import * as _ from 'lodash';
import { useCallback, useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import * as promises from '../../../shared/promises';
import * as api from '../../redux/api';
import Button from '../generic/Button';
import Icon, { icons } from '../generic/Icon';
import ModalBulkImport from '../modals/ModalBulkImport';
import type { Repository } from '../../types';

const IMPORT_CHUNK_SIZE = 25;

const GithubOrgComponent: VoidFunctionComponent = () => {
  const [orgName, setOrgName] = useState<HTMLInputElement | null>(null);
  const [focusImportOrg, setFocusImportOrg] = useState<string>('');

  const onImport = useCallback((selectedRepos: Repository[], options) => {
    const selectedRepoParams = (selectedRepos || []).map(
      ({ locator, isPrivate }) => ({ locator, private: !!isPrivate }),
    );
    const numChunks = Math.ceil(selectedRepoParams.length / IMPORT_CHUNK_SIZE);
    // eslint-disable-next-line lodash/prefer-lodash-chain
    const importChunks = _.range(numChunks).map((i) =>
      selectedRepoParams.slice(i * IMPORT_CHUNK_SIZE, (i + 1) * IMPORT_CHUNK_SIZE));

    return promises.map(importChunks, (chunk) => api.post('/api/services/github/import', {
      repos: chunk,
      options,
    }), { concurrency: 6 });
  }, []);

  return (
    <>
      <div className="card">
        <h4>
          <Icon icon={icons.github} /> Import GitHub Org
        </h4>
        <p>Point fossa to an arbitrary github org and go!</p>
        <input
          type="text"
          className="margin-right-sm"
          placeholder="GitHub Org Name"
          // TODO Figure out what this is doing.
          ref={(ref) => {
            setOrgName(ref);
          }}
        />
        <Button
          type="slate"
          isDisabled={!orgName}
          onClick={() => {
            if (orgName) {
              setFocusImportOrg(orgName.value);
            }
          }}
        >
          Import Org
        </Button>
      </div>
      <ModalBulkImport
        show={!!focusImportOrg}
        onHide={() => setFocusImportOrg(null)}
        service="github"
        filterType="organization"
        filterValue={focusImportOrg}
        onFinish={onImport}
      />
    </>
  );
};

export default GithubOrgComponent;
